import QuanLyKho from "../component/quan-ly-kho/QuanLyKho";
import PhanHeDieuChuyen from "../phan-he-dieu-chuyen/PhanHeDieuChuyen";
import PhanHeNhapKho from "../phan-he-nhap-kho/PhanHeNhapKho";
import BoSungCoSoTuTruc from "../phan-he-tu-truc/components/BoSungCoSoTuTruc";
import PhanHeXuatKho from "../phan-he-xuat-kho/PhanHeXuatKho";
import {CODE_FORM, LOAI_CHUC_NANG, TYPE_WH, WAREHOUSE_ID} from "../utils/Constant";
import DuTruBoSungVTKho from "../du-tru-bo-sung-vat-tu-kho/DuTruBoSungVTKho";
import TongHopBoSungVatTu from "../TongHopBoSungVatTu";
import DanhSachDonChiDinh from "./components/DanhSachDonChiDinh";
import DanhSachPhieuTongHop from "./components/DanhSachPhieuTongHop";
import {isCheckExistList} from "../utils/AppFunction";
export const danhSachTab = (listTabs?: any) =>  ([
    isCheckExistList(listTabs, FIELD_TABS.CODE, FIELD_TABS.DUYET_TONGHOP_DS) && {
        eventKey: "1",
        title: "Danh sách phiếu",
        component: <DanhSachDonChiDinh modelId={{
            id: "",
            type: TYPE_WH.TONG_HOP_PHIEU_CHI_DINH,
            name: 'Danh sách vật tư',
            title: 'phiếu chỉ định',
            whIssueId: 99,
        }} />,
    },
    isCheckExistList(listTabs, FIELD_TABS.CODE, FIELD_TABS.PHIEU_TONG_HOP) && {
        eventKey: "2",
        title: "Phiếu tổng hợp",
        component: <DanhSachPhieuTongHop modelId={{
            id: "",
            type: TYPE_WH.TONG_HOP_PHIEU_CHI_DINH,
            name: 'Danh sách vật tư',
            title: 'phiếu tổng hợp',
            whIssueId: 99,
        }} />,
    },
]);

export const HOAN_TRA_DVKT =  {
  DA_TONG_HOP : {
    code: "PHT",
    tracker: "tech_service_refund_summary"
  },
  CHUA_TONG_HOP: {
    code: "HTVT",
    tracker: "tech_service_refund"
  }
}

export const trackerCode = {
  issue_orders_export_summary: "issue_orders_export_summary",
  issue_orders_export: "issue_orders_export",
}

export const FIELD_TABS = {
    CODE: 'code',
    DUYET_TONGHOP_DS: 'duyet-tonghop-ds',
    PHIEU_TONG_HOP: 'duyet-tonghop-tonghop',
}
export { };
